import { Fragment } from 'react';
import { TimeUnit } from '@mews/enums';
import { ExceptionItem, ExceptionOpenHourInterval } from '../../common';

const CellExceptionsInfo = ({
    exceptions: { advance, length, price, reservationCount, secondaryRange },
    timeUnit,
    isServiceDayUse,
}: $TSFixMe) => (
    <Fragment>
        {timeUnit && timeUnit === TimeUnit.Hour ? <ExceptionOpenHourInterval /> : null}
        {advance ? <ExceptionItem type="advance" range={advance} timeUnit={timeUnit} /> : null}
        {length || secondaryRange ? (
            <ExceptionItem
                type="length"
                range={length}
                timeUnit={timeUnit}
                isServiceDayUse={isServiceDayUse}
                secondaryRange={secondaryRange}
            />
        ) : null}
        {price ? <ExceptionItem type="price" range={price} timeUnit={timeUnit} /> : null}
        {reservationCount ? (
            <ExceptionItem type="reservationCount" range={reservationCount} timeUnit={timeUnit} />
        ) : null}
    </Fragment>
);

export default CellExceptionsInfo;
